import type {SVGProps} from 'react'

const SvgLocation = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns={'http://www.w3.org/2000/svg'}
    width={24}
    height={24}
    fill={'none'}
    viewBox={'0 0 24 24'}
    {...props}
  >
    <path
      fill={'currentColor'}
      fillRule={'evenodd'}
      d={'M12 9.125a1.375 1.375 0 1 0 0 2.75 1.375 1.375 0 0 0 0-2.75M9.375 10.5a2.625 2.625 0 1 1 5.25 0 2.625 2.625 0 0 1-5.25 0'}
      clipRule={'evenodd'}
    />
    <path
      fill={'currentColor'}
      fillRule={'evenodd'}
      d={'M12 3.625c-3.819 0-6.875 2.98-6.875 6.607 0 1.157.42 2.423 1.099 3.7.675 1.272 1.584 2.512 2.504 3.607A35 35 0 0 0 12 20.918a34.932 34.932 0 0 0 3.272-3.38c.92-1.094 1.829-2.334 2.504-3.606.679-1.277 1.099-2.543 1.099-3.7 0-3.628-3.056-6.607-6.875-6.607m0 18.125-.403.478-.002-.002-.005-.004-.017-.015a12 12 0 0 1-.311-.272 36.162 36.162 0 0 1-3.49-3.592C6.817 17.21 5.85 15.894 5.12 14.52c-.728-1.37-1.245-2.844-1.245-4.287 0-4.36 3.66-7.857 8.125-7.857 4.466 0 8.125 3.497 8.125 7.857 0 1.443-.517 2.917-1.245 4.287-.73 1.375-1.697 2.69-2.652 3.824a36 36 0 0 1-3.8 3.864l-.018.015-.005.004-.002.001zm0 0 .403.477-.403.34-.403-.34z'}
      clipRule={'evenodd'}
    />
  </svg>
)
export default SvgLocation
